import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useMousetrap, useToggleState } from 'app/lib/hooks';
import { Button, ButtonVariant } from 'app/components/core/Button';
import { Time, TimeFormat } from 'app/components/core/Time';
import {
    Dialog,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalActions
} from 'app/components/core/Modal';

const clipboardContentTmpl = (_, { version, branch, revision, buildTimeStamp }) => `
Version: ${version}
Branch: ${branch}
Revision: ${revision}
Build Date: ${buildTimeStamp}
`;

export function BuildInfo({ buildInfo }) {
    const { t } = useTranslation();
    const [isDialogOpen, toggleDialog] = useToggleState(false);
    const copyToClipboard = useCallback(async () => {
        const content = clipboardContentTmpl`${buildInfo}`;
        await navigator.clipboard.writeText(content);
    }, [buildInfo]);

    useMousetrap('?', toggleDialog);

    if (!isDialogOpen) {
        return null;
    }

    return (
        <Dialog testId="build-info-dialog" onClose={toggleDialog}>
            <ModalHeader>
                <ModalTitle>{t('components:BuildInfo.title')}</ModalTitle>
            </ModalHeader>
            <ModalBody>
                {buildInfo && (
                    <dl>
                        <dt>Version:</dt>
                        <dd>{buildInfo.version}</dd>
                        <dt>Branch:</dt>
                        <dd>{buildInfo.branch}</dd>
                        <dt>Revision:</dt>
                        <dd>{buildInfo.revision}</dd>
                        <dt>Build Date:</dt>
                        <dd>
                            <Time
                                value={buildInfo.buildTimeStamp}
                                format={TimeFormat.DATETIME_MED}
                            />
                        </dd>
                    </dl>
                )}
                {!buildInfo && <p>{t('components:BuildInfo.empty')}</p>}
            </ModalBody>
            <ModalActions as="footer">
                <Button
                    variant={ButtonVariant.SECONDARY}
                    onClick={copyToClipboard}
                    disabled={!buildInfo}>
                    {t('common:copyToClipboard')}
                </Button>
                <Button variant={ButtonVariant.SPECIAL} onClick={toggleDialog}>
                    {t('common:close')}
                </Button>
            </ModalActions>
        </Dialog>
    );
}
